import React, { useEffect, useRef, useState } from "react";
import "../assets/style/pages/Services.scss";
import * as Icon from 'react-bootstrap-icons';
import { NavLink  } from "react-router-dom";

const Section = ({ data, shiftLeft }) => {

    const sectionRef = useRef(null);
    const [translateY, setTranslateY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            if (!sectionRef.current) return;
            const rect = sectionRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const scrollProgress = 1 - Math.min(Math.max(rect.top / windowHeight, 0), 1);
            setTranslateY(scrollProgress * 40);
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className="full-width-container" ref={sectionRef}>
            <img src={data.image} className="full-width-image" alt="section-img"/>
            <div className={`sliding-card ${shiftLeft ? "shiftLeft" : ""}`}>
                <div className="sliding-card-body" style={{ transform: `translateY(${translateY}px)` }}>
                    <h3 className="section-title">{data.title}</h3>
                    {data.subtitle && <h5 className="lightItalic">{data.subtitle}</h5>}
                    <div className="spacing">
                        {data.content.map((line, id) => (
                        <div key={id} className="d-flex">
                            <div className="icon"><Icon.Check size={25} /></div>
                            <p className="section-text">{line}</p>
                        </div>
                        ))}
                    </div>
                    <h4 className="section-footer">{data.price}€ / mois</h4>
                </div>
            </div>
        </div>
    )
}

const formule1 = {
    title: "Pension pré en troupeau mixte de 4 chevaux",
    subtitle: "Pour chevaux à besoins spécifiques (surpoids, fourbu, SME, …)",
    content: [
        "Stabulation ouverte",
        "Foin à volonté sous filet à foin toute l’année",
        "Pâturage tournant à la belle saison adapté aux problématiques",
        "Distribution ration 2 fois par jour"
    ],
    image: "pictures/services/pension_pre_speciaux.jpg",
    price: 380
}

const formule2 = {
    title: "Pension pré en troupeau mixte de 6 chevaux",
    content: [
        "Foin à volonté sous filet à foin toute l’année",
        "Pâturage tournant à la belle saison",
        "Distribution ration 2 fois par jour",
        "Abris naturels et artificiels"
    ],
    image: "pictures/services/pension_pre.jpg",
    price: 380
}

const formule3 = {
    title: "Pension box / pré en troupeau mixte de 5 chevaux ",
    content: [
        "Sortie quotidienne au pré (7j/7) et au box la nuit",
        "Nettoyage quotidien du box sur paille (possibilité de copeaux en supplément)",
        "Foin à volonté sous filet à foin toute l’année",
        "Pâturage tournant à la belle saison",
        "Distribution ration 2 fois par jour",
        "Abris naturels et artificiels"
    ],
    image: "pictures/services/pension_pre_box.jpg",
    price: 410
}

const formule4 = {
    title: "Pension box / terrasse / paddock individuel",
    content: [
        "Box de 3,5x4 m avec matelas confort ouvert sur une terrasse de 40 m2 et un paddock de 500 m2 en herbe pour la belle saison",
        "Nettoyage quotidien du box sur paille (possibilité de copeaux en supplément)",
        "Foin à volonté sous filet à foin toute l’année",
        "Distribution ration 2 fois par jour"
    ],
    image: "pictures/contactBack.jpg",
    price: 430
}

const Services = () => {
    return (
        <div className="page-container">
            <div className="page-header">
                <h1 className="page-title">Nos services pensions</h1>
                <p className="page-subtitle">Le Havre de Priya offre 4 différentes formules de pension afin de répondre au mieux à vos besoins et à ceux de votre compagnon.</p>
            </div>

            <div className="section">
                <Section
                    data={formule1}
                />
            </div>
            
            <div className="section">
                <Section
                    data={formule2}
                    shiftLeft={true}
                />
            </div>
                
            <div className="section">
                <Section
                    data={formule3}
                />
            </div>

            <div className="section">
                <Section
                    data={formule4}
                    shiftLeft={true}
                />
            </div>
                
            <div className="section centered-column-container primary">
                <h2 className="section-title">Nos Conditions d'arrivée</h2>
                <div className="conditions-container">
                    <div className="condition">
                        <div className="icon"><Icon.Magnet size={25} /></div>
                        <p className="section-text m-0">Déferré des postérieurs pour les chevaux en troupeau</p>
                    </div>
                
                    <h2 className="thin spacing d-lg-block d-none">|</h2>
                    <div className="condition">
                        <div className="icon"><Icon.Capsule size={25} /></div>
                        <p className="section-text m-0">Vermifuges à jour</p>
                    </div>
                    <h2 className="thin spacing d-lg-block d-none">|</h2>
                    <div className="condition">
                        <div className="icon"><Icon.JournalCheck size={25} /></div>
                        <p className="section-text m-0">Le carnet et les vaccins (tétanos/ grippe) doivent être à jour</p>
                    </div>
                </div>
            </div>
            <div className="section centered-row-container to-column">
                <img src="pictures/contactBack.jpg" className="contact-footer-image" alt="footer-image"/>
                <div className="d-flex flex-column justify-content-center align-items-md-start align-items-center spacing">
                    <h2 className="section-title">Des questions ?</h2>
                    <p className="section-text">N'hésitez pas à nous contacter par téléphone, via nos réseaux ou encore par mail afin d'échanger sur vos besoins</p>
                    <button className="action-btn large"><NavLink to="/contact">Contactez-nous</NavLink></button>
                </div>
            </div>
        </div>
    );
}
export default Services;